<template>
  <div>
    <div class="card">
      <div
        class="card-header bg-primary font-weight-bold text-white"
        style="display: flex; align-items: center"
      >
        Kehadiran Peserta
        <Button
          class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
          @click="$router.go(-1)"
          >Kembali</Button
        >
      </div>
      <form class="card-body">
        <div>
          <CRow class="mb-3">
            <div class="col-sm-12 col-xl-12">
              <div class="form-group">
              <label for="" class="font-weight-bold">Pilih Hari</label>
              <multiselect
                class="mulit-select"
                label="tanggal"
                placeholder="Pilih jadwal pelatihan"
                id="jadwalSelect"
                :show-labels="false"
                @input="getKehadiranPeserta(jadwal.idJadwalPelatihan)"
                v-model="jadwal"
                :options="dataJadwal"
              ></multiselect>
              </div>
            </div>
          </CRow>
          <div class="mt-3">
            <table class="table"> 
              <thead>
                <tr>
                  <th>No</th>
                  <th>No Anggota</th>
                  <th>Nama</th>
                  <th>Tanggal Daftar</th>
                  <th>
                    <input
                      id="terms"
                      type="checkbox"
                      @click="selectAll"
                      v-model="allSelected"
                      
                    />
                    Hadir
                  </th>
                  <th>Durasi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in items" :key="data">
                  <td>{{index+1}}</td>
                  <td>{{data.no_anggota ? data.no_anggota : '-'}}</td>
                  <td>{{data.nama_lengkap ? data.nama_lengkap : data.nama_instruktur }}</td>
                  <td>{{data.tanggal_daftar}}</td>
                  <td scope="row">
                    <input id="terms" type="checkbox" :value="data.id_kehadiran" :checked="data.checked"  @click="select($event, index)" />
                  </td>
                  <td>
                    <div class="input-group">
                      <input
                          type="number"
                          placeholder="Durasi"
                          class="form-control"
                          style="width:10px"
                          min="0"
                          :disabled="kehadiranPesertaPelatihanRequest[index].status != '1'"
                          required
                          v-model="kehadiranPesertaPelatihanRequest[index].durasi"
                          name="file"
                      />
                      <div class="input-group-prepend">
                          <div class="input-group-text">Menit</div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
           
          </div>
        </div>

      </form>
        <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3 mb-4">
          <Button
            
            style="float: right"
            class="btn btn-md btn-success px-4 py-2"
            type="submit"
            color="success"
            @click="updateKehadiran"
            >Simpan</Button
          >
          <br />
        </div>
    </div>
  </div>
</template>

<script>
import DataPesertaService from "../../../services/pelatihan/data-peserta.service";
import DataKehadiranPeserta from "../../../services/pelatihan/kehadiran-peserta.service";
import DataAnggotaService from "../../../services/keanggotaan/data-anggota.service";
import { AlertUtils } from "../../../mixins/AlertUtils"; 
import { Pagination } from "../../../mixins/Pagination";
export default {
    mixins: [
    AlertUtils, 
    Pagination
  ],
  data() {
    return {
      formData: [
        {
          item: false,
          idWorkshopPelatihan: "",
          id_workshop_pelatihan: ""
        },
      ],
      kehadiranPesertaPelatihanRequest: [],
      dataJadwal: [],
      jadwal: "",
      items: [],
      dataKehadiran: [],
      checked: false,
      selected: [],
      allCheckSelected: false,
      allSelected: false,
      allSelectedDisabled: true,
      collapseDuration: 0,
      pageSize: 10,
      content: [],
      id_pelatihan: this.$route.params.id_pelatihan
    };
  },

  mounted() {
    // this.getKehadiranPeserta();
    this.getData("0",
      this.pageSize,
      this.idWorkshopPelatihan,
      this.searchPelatihan);
    this.getJadwal();
  },

  methods: {
    updateKehadiran(){
      let loader = this.$loading.show({
        container: false ? null : this.$refs.dataDokumen,
        canCancel: true,
        onCancel: this.onCancel
      });
      var request = {
        kehadiranPesertaPelatihanRequest: this.kehadiranPesertaPelatihanRequest
      }
      DataKehadiranPeserta.postKehadiranPeserta(request)
      .then(response => {
        loader.hide();
        this.alertSuccess(response.data.message);
        this.updateKehadiranPeserta(this.jadwal.idJadwalPelatihan);
      })
      .catch((error) => {
        loader.hide();
        this.alertError(error)
      })
    },

    updateKehadiranPeserta(value) {
      this.kehadiranPesertaPelatihanRequest = [];
      this.items = [];
      DataKehadiranPeserta.getKehadiranPesertaByJadwal(value)
      .then(response => {
        // this.items = response.data.data;
        var data = response.data.data;
        data.forEach(el=>{
          if (el.status == "1") {
            this.items.push({
              created_at: el.created_at,
              created_at_trans: el.created_at_trans,
              id_jadwal_pelatihan: el.id_jadwal_pelatihan,
              id_kehadiran: el.id_kehadiran,
              nama_lengkap: el.nama_lengkap,
              no_anggota: el.no_anggota,
              status: el.status,
              tanggal_daftar: el.tanggal_daftar,
              checked: true,
              disabled: true,
              nama_instruktur : el.nama_instruktur
            })
            this.kehadiranPesertaPelatihanRequest.push({
              idKehadiran: el.id_kehadiran,
              status: "1",
              durasi : el.durasi
            })
          } else {
            this.items.push({
              created_at: el.created_at,
              created_at_trans: el.created_at_trans,
              id_jadwal_pelatihan: el.id_jadwal_pelatihan,
              id_kehadiran: el.id_kehadiran,
              nama_lengkap: el.nama_lengkap,
              no_anggota: el.no_anggota,
              status: el.status,
              tanggal_daftar: el.tanggal_daftar,
              checked: false,
              disabled: false,
              nama_instruktur : el.nama_instruktur
            })
            this.kehadiranPesertaPelatihanRequest.push({
              idKehadiran: el.id_kehadiran,
              status: "0",
              durasi : el.durasi
            })
          }
        })
        var hadir = 0;
        this.items.filter(el=>{
          if(el.status == "1") {
            hadir++;
          }
        })
        if(hadir == this.items.length) {
          this.allSelected = true;
          this.allSelectedDisabled = true;
        } else {
          this.allSelected = false;
          this.allSelectedDisabled = false;
        }
        // comment console console.log(response.data.data);
      })
    },

    getJadwal() {
      DataKehadiranPeserta.detailKehadiranPeserta(this.id_pelatihan)
      .then(response => {
        this.dataJadwal = response.data.singleData.jadwal_pelatihan;
      })
    },

    selectAll: function () {
      this.kehadiranPesertaPelatihanRequest = [];
      if (this.allSelected) {
        var data = [];
        this.items.forEach(el=>{
          if (el.status == "1") {
            data.push({
              created_at: el.created_at,
              created_at_trans: el.created_at_trans,
              id_jadwal_pelatihan: el.id_jadwal_pelatihan,
              id_kehadiran: el.id_kehadiran,
              nama_lengkap: el.nama_lengkap,
              no_anggota: el.no_anggota,
              status: el.status,
              tanggal_daftar: el.tanggal_daftar,
              checked: false,
              disabled: true,
              nama_instruktur : el.nama_instruktur
            })
          } else {
            data.push({
              created_at: el.created_at,
              created_at_trans: el.created_at_trans,
              id_jadwal_pelatihan: el.id_jadwal_pelatihan,
              id_kehadiran: el.id_kehadiran,
              nama_lengkap: el.nama_lengkap,
              no_anggota: el.no_anggota,
              status: el.status,
              tanggal_daftar: el.tanggal_daftar,
              checked: false,
              disabled: true,
              nama_instruktur : el.nama_instruktur
            })
          }
        })
        this.items = data;
        this.items.forEach(el=>{
          this.kehadiranPesertaPelatihanRequest.push({
            idKehadiran: el.id_kehadiran,
            status: "0"
          });
        })
        this.allSelected = false;
        this.checked = false;
      } else {
        var data = [];
        this.items.forEach(el=>{
          if (el.status == "1") {
            data.push({
              created_at: el.created_at,
              created_at_trans: el.created_at_trans,
              id_jadwal_pelatihan: el.id_jadwal_pelatihan,
              id_kehadiran: el.id_kehadiran,
              nama_lengkap: el.nama_lengkap,
              no_anggota: el.no_anggota,
              status: el.status,
              tanggal_daftar: el.tanggal_daftar,
              checked: true,
              disabled: false,
              nama_instruktur : el.nama_instruktur
            })
          } else {
            data.push({
              created_at: el.created_at,
              created_at_trans: el.created_at_trans,
              id_jadwal_pelatihan: el.id_jadwal_pelatihan,
              id_kehadiran: el.id_kehadiran,
              nama_lengkap: el.nama_lengkap,
              no_anggota: el.no_anggota,
              status: el.status,
              tanggal_daftar: el.tanggal_daftar,
              checked: true,
              disabled: false,
              nama_instruktur : el.nama_instruktur
            })
          }
        })
        this.items = data;
        this.items.forEach(el=>{
          this.kehadiranPesertaPelatihanRequest.push({
            idKehadiran: el.id_kehadiran,
            status: "1"
          });
        })
        this.allSelected = true;
        this.checked = true;
      }
    },

    getData(currentPage, pageSize, idWorkshopPelatihan, filter) {
      DataPesertaService.getDataPeserta(currentPage,
        pageSize,
        idWorkshopPelatihan,
        filter)
      .then(response => {
        this.item = response.data.data.content;
        // comment console console.log(response.data.data.content);
      })
    },

    getKehadiranPeserta(value) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.dataDokumen,
        canCancel: true,
        onCancel: this.onCancel
      });
      this.kehadiranPesertaPelatihanRequest = [];
      this.items = [];
      DataKehadiranPeserta.getKehadiranPesertaByJadwal(value)
      .then(response => {
        loader.hide()
        // this.items = response.data.data;
        var data = response.data.data;
        data.forEach(el=>{
          if (el.status == "1") {
            this.items.push({
              created_at: el.created_at,
              created_at_trans: el.created_at_trans,
              id_jadwal_pelatihan: el.id_jadwal_pelatihan,
              id_kehadiran: el.id_kehadiran,
              nama_lengkap: el.nama_lengkap,
              no_anggota: el.no_anggota,
              status: el.status,
              tanggal_daftar: el.tanggal_daftar,
              checked: true,
              durasi: el.durasi,
              disabled: true,
              nama_instruktur : el.nama_instruktur
            })
            this.kehadiranPesertaPelatihanRequest.push({
              idKehadiran: el.id_kehadiran,
              status: "1",
              durasi :el.durasi
            })
          } else {
            this.items.push({
              created_at: el.created_at,
              created_at_trans: el.created_at_trans,
              id_jadwal_pelatihan: el.id_jadwal_pelatihan,
              id_kehadiran: el.id_kehadiran,
              nama_lengkap: el.nama_lengkap,
              no_anggota: el.no_anggota,
              status: el.status,
              tanggal_daftar: el.tanggal_daftar,
              checked: false,
              durasi: el.durasi,
              disabled: false,
              nama_instruktur : el.nama_instruktur
            })
            this.kehadiranPesertaPelatihanRequest.push({
              idKehadiran: el.id_kehadiran,
              status: "0",
              durasi :el.durasi
            })
          }
        })
        var hadir = 0;
        this.items.filter(el=>{
          if(el.status == "1") {
            hadir++;
          }
        })
        if(hadir == this.items.length) {
          this.allSelected = true;
          this.allSelectedDisabled = true;
        } else {
          this.allSelected = false;
          this.allSelectedDisabled = false;
        }
        // comment console console.log(response.data.data);
      })
    },
  
    getDataAnggota(tahun,kategori) {
        let loader = this.$loading.show({
          container: false ? null : this.$refs.formContainer,
          canCancel: true,
          onCancel: this.onCancel
        });
        var vm = this
        
        DataAnggotaService.getDataAnggotaPeriodeTahunKategori(tahun, kategori)
          .then(response => {
            // comment console console.log(response)
            this.dataAnggota = response.data.data;
            for (let index = 0; index < this.dataAnggota.length; index++) {
              this.dataUser.push(
                {
                  id_user : null,
                  checked : false,
                }
              );
            }

            loader.hide()
          }).catch(error => {
            // comment console console.log(error);
            loader.hide()

        })
    },
    select: function(e, index) {
      var data = e.target.value;
      if(!e.target.checked) {
        this.items[index].checked = false;
        var updatedData = [];
        // this.kehadiranPesertaPelatihanRequest.filter(el=>{
        //   if(el.idKehadiran !== data) {
        //     updatedData.push(el);
        //   } else {
        //     updatedData.push({
        //       idKehadiran: data,
        //       status: "0",
        //       durasi : ''
        //     })
        //   }
        // });
        // this.kehadiranPesertaPelatihanRequest = updatedData;
        this.kehadiranPesertaPelatihanRequest[index].status = '0'
        this.allSelected = false
      } else {
        this.items[index].checked = true;
        var updatedData = [];
        this.kehadiranPesertaPelatihanRequest.filter(el=>{
          if(el.idKehadiran !== data) {
            updatedData.push(el);
          } else {
            updatedData.push({
              idKehadiran: data,
              status: "1",
              durasi : ''
            })
          }
        });
        // this.kehadiranPesertaPelatihanRequest = updatedData;
        this.kehadiranPesertaPelatihanRequest[index].status = '1'
        if(this.kehadiranPesertaPelatihanRequest.length === this.items.length) {
          this.allSelected = true;
        }
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>